<template>
	<div></div>
</template>

<script>
	export default {
		computed: {
			position() {
				return this.$route.meta.position
			}
		},

		created() {
			this.$store.commit('setPosition', this.position)
			this.$router.push('/personal')
		}
	}
</script>
